<template>
  <div>
    <v-tooltip v-bind="{ [tooltip]: true }" v-if="!hidden">
      <template #activator="{on}">
        <v-btn v-on="on" @click.capture.stop="show" class="ma-0" icon flat>
          <v-icon :color="color" class="theme--light">info_outline</v-icon>
        </v-btn>
      </template>
      <strong v-html="$t('message.metadata.moreInfo')"></strong>
    </v-tooltip>
    <nx-entity-metadata-dialog :id="id" :type="type" ref="dialog" />
  </div>
</template>
<script>
import NxEntityMetadataDialog from '@/modules/entity/metadata/EntityMetadataDialog';

export default {
  name: 'nx-entity-metadata-button',
  components: {
    NxEntityMetadataDialog,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    hidden: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    tooltip: {
      type: String,
      default: 'top',
    },
  },
  methods: {
    show() {
      this.$refs.dialog.open();
    },
  },
};
</script>
